<template>
  <!--
      作者：zhuchangtao
      时间：2020-12-12
      描述：插件中心-抽奖-抽奖设置
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <el-form-item label="是否开启抽奖活动" prop="is_lottery">
        <el-switch v-model="form.is_lottery"></el-switch>
        <!-- <p>注：如需使用分销功能必须在 [分销中心 - 分销设置] 中开启</p> -->
      </el-form-item>
      <el-form-item label="奖品领奖有效时间">
         <el-input v-model="form.prize_get_time" placeholder="请输入天数" type="number" style="width:200px"></el-input>
         <div class="tips">单位（天）</div>
       </el-form-item>
      <el-form-item label="每月抽奖日期为">
         <el-input v-model="form.lottery_time" placeholder="请输入" type="number" style="width:200px;float: left;"></el-input><div></div>
         <div class="tips" style="float: left;">号</div>
       </el-form-item>
       <el-form-item>
          <div class="tips">系统默认的抽奖时间为零点零分</div>
        </el-form-item>
     <!-- <el-form-item label="抽奖码长度设置">
        <el-input v-model="form.lottery_length" placeholder="请输入抽奖码长度" type="number" style="width:200px"></el-input>
        <div class="tips">抽奖码长度范围6-8</div>
      </el-form-item> -->

      <el-form-item label="抽奖规则">

        <div class="edit_container">
          <Uediter v-model="form.lottery_rules" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>



      <!--月抽奖-->
      <Prize :form="form"></Prize>

      <!--复活奖-->
      <Revive :form="form"></Revive>

      <!--豪华奖-->
      <Luxury :form="form"></Luxury>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import LotteryApi from '@/api/lottery.js';
import Prize from './part/Prize.vue';
import Revive from './part/Revive.vue';
import Luxury from './part/Luxury.vue';
import Uediter from '@/components/UE.vue';
export default {
  components: {
    /*编辑器*/
    Uediter,
    /*月抽奖*/
    Prize,
    /*复活奖*/
    Revive,
    /*豪华奖*/
    Luxury

  },
  data() {
    return {
      /*form表单数据*/
      form: {
        is_lottery: 'false',
        is_month_lottery: 'false',
        is_revive_lottery: 'false',
        is_luxury_lottery: 'false',
        tableData:[],
        reviveData:[],
        luxuryData:[],
        lottery_rules:''
      },
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 600,
          initialFrameHeight: 200
        }
      },
    };
  },
  created() {
    this.getData();
  },
  mounted(){
    this.getData();
  },
  methods: {

    /*获取数据*/
    getData() {
      let self = this;

      LotteryApi.settingDetail({}, true)

        .then(data => {
          self.form = data.data.vars.values;
          self.ueditor.text = data.data.vars.values.lottery_rules;
          var tableData = [];
          data.data.vars.values.tableData.forEach(item =>{
            //JSON.parse()
              tableData.push(JSON.parse(item))

          })
          self.form.tableData = tableData;

          var reviveData = [];
          data.data.vars.values.reviveData.forEach(item =>{
            //JSON.parse()
              reviveData.push(JSON.parse(item))

          })
          self.form.reviveData = reviveData;

          var luxuryData = [];
          data.data.vars.values.luxuryData.forEach(item =>{
            //JSON.parse()
              luxuryData.push(JSON.parse(item))

          })
          self.form.luxuryData = luxuryData;
          if (self.form.is_lottery == 'true') {
            self.form.is_lottery = true;
          }

        })
        .catch(error => {});
    },

    /*提交表单*/
    onSubmit() {
      let self = this;
      let params = this.form;
      params.lottery_rules = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          LotteryApi.editSetting(params, true)
            .then(data => {
              self.$message({
                message: '恭喜你，设置成功',
                type: 'success'
              });
              this.getData();
            })
            .catch(error => {});

        }
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/lottery/setting/index.vue